import {Icon} from 'layout/Icon'
import React, {HTMLProps} from 'react'
import {Link} from 'util/link'
import {Variant} from 'util/styler'
import {fromModule} from 'util/styler/Styler'
import css from './LinkStyled.module.scss'

const styles = fromModule(css)

type LinkModType = {
	mod?: Variant<'small' | 'large' | 'minwidth' | 'fullwidth' | 'aligncenter'>
}

type LinkIconType = 'arrow_diagonal' | 'arrow_left'

export const LinkStyled: React.FC<
	HTMLProps<HTMLAnchorElement> &
		LinkModType & {
			to?: string
			iconbefore?: LinkIconType
			iconafter?: LinkIconType
		}
> = ({to, mod, iconbefore, iconafter, children, ...props}) => {
	return (
		<div className={styles.linkstyled.with(props.className)()}>
			<Link
				{...(props as any)}
				to={to}
				className={styles.linkstyled.link.mod(mod)()}
			>
				{iconbefore && <LinkStyledIcon icon={iconbefore} />}
				<LinkStyledText>{children}</LinkStyledText>
				{iconafter && <LinkStyledIcon icon={iconafter} />}
			</Link>
		</div>
	)
}

const LinkStyledText: React.FC = ({children}) => (
	<span className={styles.linkstyled.link.text()}>
		<span className={styles.linkstyled.link.text.label()}>{children}</span>
	</span>
)

const LinkStyledIcon: React.FC<{
	icon: LinkIconType
}> = ({icon}) => (
	<span className={styles.linkstyled.link.icon.mod(icon)()}>
		<Icon icon={icon} />
	</span>
)
